// ============================================================================
// Steadfastly - Error Handling Utilities
// SEC-04: Sanitize error messages to prevent internal detail exposure
// ============================================================================

export function sanitizeErrorMessage(err) {
  if (!err) return "An unexpected error occurred";
  const msg = typeof err === "string" ? err : err.message || String(err);
  
  // Map known internal errors to user-friendly messages
  const sensitivePatterns = [
    { pattern: /PGRST\d+/i, replacement: "Database error" },
    { pattern: /violates.*constraint/i, replacement: "Data validation error" },
    { pattern: /duplicate key/i, replacement: "This item already exists" },
    { pattern: /foreign key/i, replacement: "Related data conflict" },
    { pattern: /relation.*does not exist/i, replacement: "Configuration error" },
    { pattern: /column.*does not exist/i, replacement: "Configuration error" },
    { pattern: /permission denied/i, replacement: "Access denied" },
    { pattern: /JWT|token|auth/i, replacement: "Authentication error" },
    { pattern: /function.*does not exist/i, replacement: "Server configuration error" },
    { pattern: /syntax error/i, replacement: "Invalid request" },
    { pattern: /timeout|timed out/i, replacement: "Request timed out. Please try again." },
    { pattern: /network|fetch|CORS/i, replacement: "Network error. Please check your connection." },
    { pattern: /rate limit/i, replacement: "Too many requests. Please wait a moment." },
    { pattern: /storage|bucket/i, replacement: "File storage error" },
  ];
  
  for (const { pattern, replacement } of sensitivePatterns) {
    if (pattern.test(msg)) {
      // Log original for debugging (in console only)
      console.error("Original error:", msg);
      return replacement;
    }
  }
  
  // If message is very long (likely a stack trace), truncate
  if (msg.length > 200) {
    console.error("Original error:", msg);
    return msg.slice(0, 100) + "...";
  }
  
  return msg;
}

// Safe JSON parse - Red Team Phase 1 localStorage Fix
export function safeJsonParse(value, defaultValue = null) {
  if (!value) return defaultValue;
  try {
    return JSON.parse(value);
  } catch (e) {
    console.error('Failed to parse JSON from localStorage:', e);
    return defaultValue;
  }
}
